import getItem from 'owa-mail-store/lib/services/getItem';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';

export default async function getItemIdFromInternetMessageId(
    internetMessageId: string
): Promise<string> {
    const itemShape = itemResponseShape({
        BaseShape: 'IdOnly',
    });

    try {
        const itemOrError = await getItem(
            null,
            itemShape,
            undefined /*shapeName*/,
            undefined /*requestServerVersion*/,
            undefined /*mailboxInfo*/,
            undefined /*options*/,
            undefined /*isDiscovery*/,
            internetMessageId
        );
        if (itemOrError && !(itemOrError instanceof Error)) {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2532 (26,20): Object is possibly 'undefined'.
            // @ts-expect-error
            return itemOrError[0].ItemId.Id;
        }
    } catch (e) {}

    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (33,5): Type 'null' is not assignable to type 'string'.
    // @ts-expect-error
    return null;
}
